import cn from "@/v2-ui/utils/utils.cn"
import Dot from "@/v2-backoffice-client/components/dot/Dot"
import Link from "@/v2-backoffice-client/components/link"
import { getTranslationCategoryHref } from "@/v2-backoffice-client/translation/translation.utils"
import type { TranslationCategory } from "@/v2-backoffice-client/translation/translation.types"

export type TranslationSidebarCategoryItemProps = {
  category: TranslationCategory
  isActive: boolean
}

function TranslationSidebarCategoryItem(
  props: TranslationSidebarCategoryItemProps,
) {
  const { category, isActive } = props

  return (
    <Link
      to={getTranslationCategoryHref(category.key)}
      variant="unstyled"
      iconSrc={null}
      data-feature-code="UI_BackofficeTranslation_Sidebar_Category"
      title={`${category.key}: ${category.total} feature(s), ${category.incomplete} missing one or more languages`}
      aria-current={isActive ? "page" : undefined}
      className={cn(
        "translation-sidebar-item",
        isActive && "translation-sidebar-item-active",
      )}
    >
      <Dot
        variant={category.incomplete > 0 ? "warning" : "success-1"}
        className="shrink-0"
      />
      <span className="translation-sidebar-item-name">{category.label}</span>
      <span className="translation-sidebar-item-count">
        {category.total - category.incomplete}
        <span className="text-muted-foreground">/{category.total}</span>
      </span>
    </Link>
  )
}

export default TranslationSidebarCategoryItem
